document.addEventListener("DOMContentLoaded", function() {
    var variantSelect = document.querySelector("select[name='id']");
    
    if (variantSelect) {
        variantSelect.addEventListener("change", function() {
            var selectedVariantId = this.value;
            
            // Suche die passende Lieferzeit für die gewählte Variante
            var lieferzeitElement = document.getElementById("lieferzeit");
            var selectedLieferzeit = document.querySelector(`.lieferzeit-text[data-variant-id='${selectedVariantId}']`);

            if (lieferzeitElement && selectedLieferzeit) {
                lieferzeitElement.innerText = selectedLieferzeit.dataset.lieferzeit;
            }
        });
    }
});
